import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

export interface IntegrityMetric {
  propertyId: string
  name: string
  unit: string
  category: string
}

@Injectable({
  providedIn: 'root'
})
export class IntegrityMetricService {

  url = `${environment.API_INSPEC}IntegrityMetric`

  constructor(
    private http: HttpClient
  ) { }

  getAllProperties() {
    return this.http.get<IntegrityMetric[]>(this.url);
  }
}
